import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-header">
            <h2>Ready to Transform Your Events?</h2>
            <p>If you are an exhibitor wanting to use Scan2Card in your events, we'd love to help you get started.</p>
          </div>
          
          <div className="contact-methods">
            <div className="contact-card">
              <div className="contact-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <h3>Email Us</h3>
              <p>Get in touch with our team</p>
              <a href="mailto:support@scan2card.com" className="contact-link">
                support@scan2card.com
              </a>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <h3>Call Us</h3>
              <p>Speak directly with our experts</p>
              <a href="tel:+917263889831" className="contact-link">
                +91 7263889831
              </a>
            </div>
          </div>

          <div className="contact-cta">
            <p>We'll help you set up Scan2Card for your next event and ensure your team gets the most out of our lead collection platform.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;